export default __webpack_public_path__ + "b387f7b66b60bdffc9c6dc97adf93e25.jpg";